export const BACKEND_URL = "https://us-central1-eyeary-544dd.cloudfunctions.net"